import { render, staticRenderFns } from "./AdminEditInfo.vue?vue&type=template&id=8fba34d6&"
import script from "./AdminEditInfo.vue?vue&type=script&lang=js&"
export * from "./AdminEditInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports